module.exports = __webpack_public_path__ + "img/@work_welstory_list.173276b8.png";